import { EmployeeAttendanceMode } from '../config/employeeAttendance';

export const EmployeeAttendanceSimpleMode = (mode) =>
  [EmployeeAttendanceMode.DIALOG, EmployeeAttendanceMode.PHONE].includes(mode);
